<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
         <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增</el-button>
          </div>
        </zv-table>
    <zv-dialog
      width="400px"
      :title="isEdit ? '修改' : '新增'"
      :showDialog.sync="showFormDialog"
      @close-dialog="closeFormDialog"
    >
      <div slot="content">
        <el-form
          ref="myForm"
          label-width="100px"
          :model="formData"
          :rules="formRules"
          status-icon
        >
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="formData.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="照片:" prop="photo">
                <div v-if="formData.photo" style="margin-bottom: 10px;">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="formData.photo"
                    fit="fill"
                    :preview-src-list="[formData.photo]"
                  >
                  </el-image>
                </div>
                <div>
                  <el-upload
                    :action="imageUrl"
                    accept="image/*"
                    :show-file-list="false"
                    :data="imageData"
                    name="file"
                    v-model="formData.photo"
                    :on-success="handleUploadSuccess"
                  >
                    <el-button size="small" type="primary">点击上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>
          <el-form-item label="地址：">
            <el-input v-model="formData.address" clearable></el-input>
          </el-form-item>
          <el-form-item label="介绍：" prop="intro">
            <el-input type="textarea" :autosize="{ minRows: 3,minCols: 20}" v-model="formData.intro" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <el-button @click="showFormDialog = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </zv-dialog>
  </div>
   </div>
  </div>
</template>

<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import tokenService from "@/utils/services/token_service";
export default {
  name: "mediaLibrary",
  mixins: [addFormMixin],
  data() {
    let vm = this;
    return {
      addressSelectData: null,
      addressItem: null,
      name: "",
      currentPage: 1,
      totalList: null,
       table: {
        api: api.mediaList,
        query: {

        },
        searchData: [
          {
            type: "input",
            model: "name",
            placeholder: "姓名"
          }
        ],
        columns: [
          {
            title: "姓名",
            key: "name",
            minWidth:"100",
          },
          {
            title: "照片",
            minWidth:"120",
            render(h, ctx) {
              return h("img", {
                  attrs: {
                    src: ctx.row.photo,
                    style: "width: 80px;height: 80px"
                  }
                });
            }
          },
          {
            title: "地址",
            key: "address",
            minWidth:"100",
            showTooltip: true
          },
          {
            title: "简介",
            key: "intro",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "90",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"

              );

              let arr = [];
              arr.push(editBtn);
              return h("span", arr);
            }
          }
        ]
      },
      adddApi: api.addMedia,
      editApi: api.editMedia,
      addSuccessMsg: '添加成功',
      editSuccessMsg: '编辑成功',
      deleteSuccessMsg: '删除成功',
      formRules: {
        name: [{
          required: true,
          message: "姓名不能为空",
          trigger: "blur"
        }],
        photo: [{
          required: true,
          message: "照片不能为空",
          trigger: "change"
        }]
      },
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "article_media_photo"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
    };
  },
  created() {
    // this.getData();
  },
  methods: {
    // 图片上传成功
    handleUploadSuccess(res, file) {
      this.$set(this.formData, "photo", res.file);
    },
    // // 获取数据
    // getData(data) {
    //   api
    //     .expertList(data)
    //     .then(res => {
    //       // this.$message("请求成功!");
    //       this.tableData = res.list;
    //       this.totalList = res.recordcount;
    //       this.pageSize = res.pagecount;
    //       // console.log(res);
    //     })
    //     .catch(err => {
    //       // console.log(err);
    //     });
    // },

    // 查询参数
    // queryData() {
    //   let data = {
    //     name: this.name
    //   };
    //   if (data.name) {
    //     this.getData(data);
    //   } else {
    //     this.getData();
    //   }
    // },

    // 新增数据
    doAddExtra() {
      // this.formRules = Object.assign({}, this.formRulesOri, this.pwdRule)
      console.log(this.formRules)
    },


    // 删除数据
    deleteData(row) {
      debugger;
      let data = {
        id: row.id
      };
      this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(data);
        })
        .catch(() => {});
    },

    delete(data) {
      api
        .recordedDelete(data)
        .then(res => {
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.getData();
        })
        .catch(err => {});
    },

    //改变每页显示数量重新请求数据，重置当前页为第一页
    handleSizeChange(val) {
      let pageSize = { pagesize: val };
      this.getData(pageSize);
    },

    //点击改变当前页
    handleCurrentChange(val) {
      let page = { page: val };
      this.getData(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>